export const httpPoint = {
    user: '/users/',
    links: '/users/links/',
}

export const linkType = [
    'constant', 'disposable', 'temporary'
]

export const expirationTimeLimits = {
    minValue: 5,
    maxValue: 24 * 60
}







 
